export default "__VITE_ASSET__ca513360__"